document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("product-slider");
  const prevButton = document.querySelector(".slider-arroww--prev");
  const nextButton = document.querySelector(".slider-arroww--next");

  if (!slider || !prevButton || !nextButton) {
    console.error("❌ Product slider setup failed: Missing elements");
    return;
  }

  const items = [...slider.children];
  const totalItems = items.length;

  if (totalItems === 0) {
    console.error("❌ No products found inside .product-slider-list");
    return;
  }

  console.log("✅ Products Loaded: ", totalItems);

  if (window.innerWidth > 749) { // Apply only for desktop
    setupInfiniteScroll();
  }

  function setupInfiniteScroll() {
    // Duplicate all slides for infinite effect
    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.classList.add("cloned");
      slider.appendChild(clone);
    });

    // Set initial scroll position to middle
    slider.scrollLeft = slider.scrollWidth / 2;

    // Reset scroll position when reaching cloned elements
    slider.addEventListener("scroll", function () {
      if (slider.scrollLeft <= 0) {
        slider.scrollLeft = slider.scrollWidth / 2;
      } else if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1) {
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add("cloned");
          slider.appendChild(clone);
        });
      }
    });
  }

  function smoothScroll(direction) {
    const scrollAmount = 300; // Adjust based on card width
    slider.scrollBy({ left: direction * scrollAmount, behavior: "smooth" });
  }

  prevButton.addEventListener("click", () => smoothScroll(-1));
  nextButton.addEventListener("click", () => smoothScroll(1));

  console.log("✅ Product slider initialized successfully.");
});
